module.exports = __webpack_public_path__ + "img/newUserTip.8ed98fad.svg";